import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { ConversationsProvider } from "./context/ConversationsContext";
import { LicenseProvider } from "./context/LicenseContext";
import { ThemeProvider } from "./context/ThemeContext";
import "./styles/tailwind.css";
import "./styles/global.css";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <LicenseProvider>
              <ConversationsProvider>
                <App />
              </ConversationsProvider>
            </LicenseProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
